import { useDisclosure } from "@mantine/hooks";
import { Fragment, useState } from "react";
import ApiHistoryModal from "src/components/shared/ApiHistoryModal/ApiHistoryModal";
import ScrollableTable from "src/components/shared/ScrollableTable/ScrollableTable";
import { type Stamp } from "src/interfaces/Stamps";

import ShipsStampsListItem from "./ShipsStampsListItem";
const headers = [
  { name: "name", label: "Name" },
  { name: "image", label: "Image" },
  { name: "reports", label: "Assigned Logbooks/Reports" },
  { name: "del", label: "", width: 50 },
];

interface Props {
  stamps: Stamp[];
  isLoading: boolean;
  refetchStamps: () => void;
}

const ShipsStampsList = ({ stamps, isLoading, refetchStamps }: Props) => {
  const [
    historyModalOpened,
    { open: openHistoryModal, close: closeHistoryModal },
  ] = useDisclosure(false);
  const [selectedRow, setSelectedRow] = useState<Stamp | undefined>();

  const handleClose = () => {
    setSelectedRow(undefined);
    closeHistoryModal();
  };
  const handleOpen = (row: Stamp) => {
    setSelectedRow(row);
    openHistoryModal();
  };
  const renderRow = (data: { row: Stamp }) => {
    // eslint-disable-next-line react/prop-types
    return (
      <ShipsStampsListItem
        {...data.row}
        refetchStamps={refetchStamps}
        handleOpenHistoryModal={() => handleOpen(data.row)}
      />
    );
  };

  return (
    <Fragment>
      <ScrollableTable
        style={{ padding: 20 }}
        data={stamps}
        headers={headers}
        renderRow={renderRow}
        loading={isLoading}
        sortable
      />
      <ApiHistoryModal
        opened={historyModalOpened}
        close={handleClose}
        elementName={selectedRow?.name}
        params={{ stampid: selectedRow?.stampid }}
        apiUrl="get-stamp-history"
      />
    </Fragment>
  );
};
export default ShipsStampsList;
